import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import dropdownService from './dropdownService';

// Slice for getting Category dropdown
export const getCategoryDropdwon = createAsyncThunk('/getCategoryDropdwon', async (thunkAPI) => {
	try {
		const response = await dropdownService.getCategoryDropdwon();
		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});

// Slice for getting SubCategory Dropdwon
export const getSubCategoryDropdwon = createAsyncThunk(
	'/getSubCategoryDropdwon',
	async (thunkAPI) => {
		try {
			const response = await dropdownService.getSubCategoryDropdwon();
			return response;
		} catch (error) {
			const message =
				(error.response && error.response.data && error.response.data.message) ||
				error.message ||
				error.toString();
			return thunkAPI.rejectWithValue(message);
		}
	}
);

// Slice for getting Size Dropdwon
export const getSizeDropdwon = createAsyncThunk('/getSizeDropdwon', async (thunkAPI) => {
	try {
		const response = await dropdownService.getSizeDropdwon();
		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});

// Slice for getting Size Dropdwon
export const getColorDropdown = createAsyncThunk('/getColorDropdown', async (thunkAPI) => {
	try {
		const response = await dropdownService.getColorDropdown();
		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});

// Slice for getting Size Dropdwon
export const getBrandDropdown = createAsyncThunk('/getBrandDropdown', async (thunkAPI) => {
	try {
		const response = await dropdownService.getBrandDropdown();
		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});

// Slice for getting Size Dropdwon
export const getStyleCodeDropdown = createAsyncThunk('/getStyleCodeDropdown', async (thunkAPI) => {
	try {
		const response = await dropdownService.getStyleCodeDropdown();
		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});

// Slice for getting Label Dropdwon
export const getLabelTypeDropdown = createAsyncThunk('/getLabelTypeDropdown', async (thunkAPI) => {
	try {
		const response = await dropdownService.getLabelTypeDropdown();
		return response;
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString();
		return thunkAPI.rejectWithValue(message);
	}
});

const initialState = {
	categoryDropdown: [],
	subCategoryDropdown: [],
	sizeDropdown: [],
	colorDropdown: [],
	brandDropdown: [],
	styleCodeDropdown: [],
	labelTypeDropdown: [],
	isError: false,
	isLoading: false,
	isSuccess: false,
	message: '',
};

const dropdownSlice = createSlice({
	name: 'dropdown',
	initialState,
	reducers: {
		reset: (state) => {
			state.categoryDropdown = [];
			state.subCategoryDropdown = [];
			state.sizeDropdown = [];
			state.colorDropdown = [];
			state.brandDropdown = [];
			state.styleCodeDropdown = [];
			state.isLoading = false;
			state.isError = false;
			state.isSuccess = false;
			state.message = '';
		},
	},

	extraReducers: (builder) => {
		builder
			.addCase(getCategoryDropdwon.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getCategoryDropdwon.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.categoryDropdown = action.payload.dropdownData;
				state.isError = false;
			})
			.addCase(getCategoryDropdwon.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.payload;
			})
			.addCase(getSubCategoryDropdwon.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getSubCategoryDropdwon.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.subCategoryDropdown = action.payload.dropdownData;
				state.isError = false;
			})
			.addCase(getSubCategoryDropdwon.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.payload;
			})
			.addCase(getSizeDropdwon.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getSizeDropdwon.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.sizeDropdown = action.payload.dropdownData;
				state.isError = false;
			})
			.addCase(getSizeDropdwon.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.payload;
			})
			.addCase(getColorDropdown.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getColorDropdown.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.colorDropdown = action.payload.dropdownData;
				state.isError = false;
			})
			.addCase(getColorDropdown.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.payload;
			})
			.addCase(getBrandDropdown.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getBrandDropdown.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.brandDropdown = action.payload.dropdownData;
				state.isError = false;
			})
			.addCase(getBrandDropdown.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.payload;
			})
			.addCase(getStyleCodeDropdown.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getStyleCodeDropdown.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.styleCodeDropdown = action.payload.dropdownData;
				state.isError = false;
			})
			.addCase(getStyleCodeDropdown.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.payload;
			})
			.addCase(getLabelTypeDropdown.pending, (state) => {
				state.isLoading = true;
				state.isError = false;
				state.isSuccess = false;
			})
			.addCase(getLabelTypeDropdown.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.labelTypeDropdown = action.payload.dropdownData;
				state.isError = false;
			})
			.addCase(getLabelTypeDropdown.rejected, (state, action) => {
				state.isLoading = false;
				state.isSuccess = false;
				state.isError = true;
				state.message = action.payload;
			});
	},
});

export const { reset, resetMessage } = dropdownSlice.actions;
export default dropdownSlice.reducer;
